import { Controller } from "@hotwired/stimulus";

// Live example under the room form's bed name prefix: "A" -> "Beds will be
// named A-01, A-02, A-03". The two sentences come from the server so the
// preview stays translated.
//
//   <div data-controller="bed-name-prefix"
//        data-bed-name-prefix-preview-value="Beds will be named %{example}"
//        data-bed-name-prefix-blank-value="Leave blank to name beds yourself.">
//     <input data-action="input->bed-name-prefix#preview">
//     <p data-bed-name-prefix-target="preview"></p>
//   </div>
export default class extends Controller<HTMLElement> {
  static targets = ["preview"];
  static values = { preview: String, blank: String };

  declare readonly previewTarget: HTMLElement;
  declare readonly previewValue: string;
  declare readonly blankValue: string;

  preview(event: Event) {
    const prefix = (event.target as HTMLInputElement).value.trim();
    if (!prefix) {
      this.previewTarget.textContent = this.blankValue;
      return;
    }

    const example = ["01", "02", "03"].map((n) => `${prefix}-${n}`).join(", ");
    this.previewTarget.textContent = this.previewValue.replace("%{example}", example);
  }
}
